import { Routes, Route } from "react-router-dom";
import LogisticCompoundTable from "../component/logisticCompound/logisticCompoundTable";
import LCDetailsPage from "../component/logisticCompound/LCDetailsPage";

const LogisticCompoundPage = () => {
  return (
    <Routes>
      <Route index={true} element={<LogisticCompoundTable />} />
      <Route path="/details/:id/*" element={<LCDetailsPage />} />
    </Routes>
  );
};

export default LogisticCompoundPage;
